import {
  Box,
  Button,
  Flex,
  Text,
  Image as ImageComponent,
} from "@chakra-ui/react";
import Image from "next/legacy/image";
import Head from "next/head";
import React from "react";
import { WrapperStyle } from "../styles/newDesignStyles";
import {
  HeroBanner,
  HeroBannerTitle,
  HeroBannerHeader,
  BannerImageContainer,
  OurPurposeContainer,
  OurPurposeTitle,
  OurPurposeHeader,
  PurposeContentContainer,
  PurposeContentContainerMobile,
  LeadershipHeader,
  StatsCardContainer,
  ContactText,
} from "../styles/AboutStyles";
import { StatsTextContainer } from "../styles/LandingStyles";
import useWindowSize from "../components/Utility/windowSize";
import { FaLinkedin } from "react-icons/fa";
import Link from "next/link";

const About_us = () => {
  const [readMore, setReadMore] = React.useState(false);
  const size = useWindowSize();

  const toggleReadMore = () => {
    setReadMore(!readMore);
  };

  return (<>
    <Head>
      <title key="title">
        Zonado - About Zonado, Our Company and Culture
      </title>
      <meta
        key="description"
        name="description"
        content="Meet the team behind Zonado – Canada’s fastest growing sale of business and commercial real estate listing and buying platform "
      />
      <meta
        key="og:title"
        property="og:title"
        content="Zonado - About Zonado, Our Company and Culture"
      />
      <meta
        key="og:description"
        property="og:description"
        content="Meet the team behind Zonado – Canada’s fastest growing sale of business and commercial real estate listing and buying platform "
      />
      <link rel="canonical" href="https://zonado.com/about-us" />
    </Head>
    {/* Our story */}
    <HeroBanner>
      <Box maxW={"1440px"} m="0 auto">
        <Box m="0 auto">
          <HeroBannerTitle>About Us</HeroBannerTitle>
          <HeroBannerHeader>
            We live and breathe Canadian small business.
          </HeroBannerHeader>
        </Box>
        <BannerImageContainer>
          <Image
            src="/images/about/banner-image.svg"
            width={"840px"}
            height="361px"
            style={{
              maxWidth: "100%",
              height: "auto"
            }} />
        </BannerImageContainer>
      </Box>
    </HeroBanner>
    <WrapperStyle>
      <OurPurposeTitle>Our Purpose</OurPurposeTitle>
      <OurPurposeContainer>
        <OurPurposeHeader>
          We are making it easier than ever for Canadians to find their next
          business opportunity or commercial real estate investment.
        </OurPurposeHeader>
        <Text>
          Zonado started when the brother-sister team of Harjaap and Suhavi
          set out to find a small warehouse space to help their parents'
          business expand. When they experienced the broken, inefficient
          process firsthand, it became clear that they couldn't have been the
          only ones looking for a better solution.
        </Text>
        {size.width >= 772 ? (
          <>
            <Text>
              Since launching publicly in May of 2021, Zonado has come to be
              loved by thousands of industry professionals, investors, and
              business owners nationwide and has become an indispensable part
              of their toolkits.
            </Text>
            <Text>
              We are on a mission to allow Canadians to transact commercial
              real estate and businesses faster, and with more confidence than
              ever before. Finding a commercial opportunity is always the
              beginning of something great. We're here to make that process as
              seamless as possible.
            </Text>
          </>
        ) : (
          readMore && (
            <>
              <Text>
                Since launching publicly in May of 2021, Zonado has come to be
                loved by thousands of industry professionals, investors, and
                business owners nationwide and has become an indispensable
                part of their toolkits.
              </Text>
              <Text>
                We are on a mission to allow Canadians to transact commercial
                real estate and businesses faster, and with more confidence
                than ever before. Finding a commercial opportunity is always
                the beginning of something great. We're here to make that
                process as seamless as possible.
              </Text>
            </>
          )
        )}
        {size.width < 772 && (
          <Box pt="20px">
            <Text
              fontSize="20px"
              lineHeight={"30px"}
              as="u"
              onClick={() => toggleReadMore()}
            >
              {readMore ? "Show less" : "Continue reading"}
            </Text>
          </Box>
        )}
      </OurPurposeContainer>
    </WrapperStyle>
    <WrapperStyle>
      <Box position={"relative"} m="0 auto" pt="176px">
        <Box textAlign={"center"}>
          <Text
            color="#125F3F"
            fontWeight={500}
            fontSize="24px"
            lineHeight={"28px"}
          >
            Our Leadership
          </Text>
          <LeadershipHeader>Meet the people behind Zonado</LeadershipHeader>
        </Box>
      </Box>
    </WrapperStyle>
    <Flex
      maxW="1440px"
      m="0 auto"
      mt={"48px"}
      flexDir={"row"}
      flexWrap={"wrap"}
      justifyContent={"center"}
    >
      <Flex flexDir={"row"} flexWrap={"wrap"} justifyContent={"space-evenly"}>
        <Box
          w={{ base: "196px", sm: "230px", md: "270px", lg: "318px" }}
          mb={{ base: "32px", md: "73px" }}
          px="10px"
        >
          <Image
            src={"/images/about/suhavi.jpg"}
            alt={"Suhavi Makkar"}
            width={"318px"}
            height={"450px"}
            style={{
              borderRadius: "20px",
              maxWidth: "100%",
              height: "auto"
            }} />
          <Flex justify={"space-between"} alignItems={"center"}>
            <Box>
              <Text
                textAlign="start"
                mt={"16px"}
                fontSize={{ base: "16px", sm: "18px", md: "20px" }}
                lineHeight={{ base: "25px", sm: "27.5px", md: "28px" }}
                letterSpacing={"0.8px"}
                fontWeight={700}
              >
                Suhavi Makkar
              </Text>
              <Text
                textAlign="start"
                mt={"3px"}
                fontSize={{ base: "16px", md: "18px" }}
                lineHeight={{ base: "25px", md: "28px" }}
                letterSpacing={"-0.5px"}
                color={"#364354"}
              >
                CEO & Co-Founder
              </Text>
            </Box>
            <Flex
              justifyContent={{ base: "center", sm: "start" }}
              mt={"16px"}
            >
              <a
                href={"https://linkedin.com/in/suhavimakkar"}
                target={"_blank"}
              >
                <FaLinkedin color={"gray"} size={"18px"} />
              </a>
            </Flex>
          </Flex>
        </Box>
        <Box
          w={{ base: "196px", sm: "230px", md: "270px", lg: "318px" }}
          mb={{ base: "32px", md: "73px" }}
          px="10px"
        >
          <Image
            src={"/images/newLanding/harjaap.png"}
            alt={"Harjaap Singh"}
            width={"318px"}
            height={"450px"}
            style={{
              borderRadius: "20px",
              maxWidth: "100%",
              height: "auto"
            }} />
          <Flex justify={"space-between"} alignItems={"center"}>
            <Box>
              <Text
                textAlign="start"
                mt={"16px"}
                fontSize={{ base: "16px", sm: "18px", md: "20px" }}
                lineHeight={{ base: "25px", sm: "27.5px", md: "28px" }}
                letterSpacing={"0.8px"}
                fontWeight={700}
              >
                Harjaap Singh
              </Text>
              <Text
                textAlign="start"
                mt={"3px"}
                fontSize={{ base: "16px", md: "18px" }}
                lineHeight={{ base: "25px", md: "28px" }}
                letterSpacing={"-0.5px"}
                color={"#364354"}
              >
                CTO & Co-Founder
              </Text>
            </Box>
            <Flex
              justifyContent={{ base: "center", sm: "start" }}
              mt={"16px"}
            >
              <a
                href={"https://linkedin.com/in/harjaapsinghmakkar"}
                target={"_blank"}
              >
                <FaLinkedin color={"gray"} size={"18px"} />
              </a>
            </Flex>
          </Flex>
        </Box>
      </Flex>
      <Flex flexDir={"row"} flexWrap={"wrap"} justifyContent={"space-evenly"}>
        <Box
          w={{ base: "196px", sm: "230px", md: "270px", lg: "318px" }}
          mb={{ base: "32px", md: "73px" }}
          px="10px"
        >
          <Image
            src={"/images/about/anthony.jpg"}
            alt={"Anthony Nguyen"}
            width={"318px"}
            height={"450px"}
            style={{
              borderRadius: "20px",
              maxWidth: "100%",
              height: "auto"
            }} />
          <Flex justify={"space-between"} alignItems={"center"}>
            <Box>
              <Text
                textAlign="start"
                mt={"16px"}
                fontSize={{ base: "16px", sm: "18px", md: "20px" }}
                lineHeight={{ base: "25px", sm: "27.5px", md: "28px" }}
                letterSpacing={"0.8px"}
                fontWeight={700}
              >
                Anthony Nguyen
              </Text>
              <Text
                textAlign="start"
                mt={"3px"}
                fontSize={{ base: "16px", md: "18px" }}
                lineHeight={{ base: "25px", md: "28px" }}
                letterSpacing={"-0.5px"}
                color={"#364354"}
              >
                Advisor
              </Text>
            </Box>
            <Flex
              justifyContent={{ base: "center", sm: "start" }}
              mt={"16px"}
            >
              <a
                href={"https://linkedin.com/in/anthonynguyen94"}
                target={"_blank"}
              >
                <FaLinkedin color={"gray"} size={"18px"} />
              </a>
            </Flex>
          </Flex>
        </Box>

      </Flex>
    </Flex>
    <Box bgColor="#0A3423">
      <WrapperStyle>
        <Box maxW={"1440px"} m="0 auto" p="70px 0 224px">
          <Text
            pos={"relative"}
            top="70px"
            zIndex={1}
            color="white"
            fontWeight={500}
            fontSize="24px"
            lineHeight={"29px"}
            textAlign="center"
          >
            Who we help
          </Text>
        </Box>
        {size.width >= 936 ? (
          <>
            <Flex
              justifyContent={"space-evenly"}
              height="fit-content"
              pb="130px"
            >
              <Box pos="relative">
                <Image
                  src="/images/about/left-blob.svg"
                  width={size.width >= 1050 ? "472px" : "355px"}
                  height={size.width >= 1050 ? "569px" : "425px"}
                  style={{
                    maxWidth: "100%",
                    height: "auto"
                  }} />
                <Box pos={"absolute"} top="47px">
                  <Image
                    src="/images/about/investors-and-tenants.svg"
                    width={size.width >= 1050 ? "402px" : "245px"}
                    height={size.width >= 1050 ? "543px" : "325px"} />
                </Box>
              </Box>
              <PurposeContentContainer>
                <Box w={"561px"}>
                  <Text>Investors & Tenants</Text>
                  <Text display={"block"} color="#c1bfbd">
                    By removing the clutter from their search for a property{" "}
                  </Text>
                </Box>
                <Box
                  w="549px"
                  pt="17px"
                  color="#c1bfbd"
                  fontSize={"18px"}
                  fontStyle="normal"
                  lineHeight={"28px"}
                  letterSpacing={"-0.44px"}
                  fontWeight={500}
                >
                  From searching for an investment opportunity to finding a
                  space for a business to operate out of, the entire process
                  is becoming faster, easier, and more trustworthy on Zonado.
                </Box>
              </PurposeContentContainer>
            </Flex>
            <Flex justifyContent={"space-evenly"} pb="130px">
              <PurposeContentContainer middle>
                <Box>
                  <Text>Property & business owners</Text>
                  <Text display={"block"} color="#c1bfbd">
                    By streamlining the search for a buyer
                  </Text>
                </Box>
                <Box
                  w="579px"
                  pt="17px"
                  color="#c1bfbd"
                  fontSize={"18px"}
                  fontStyle="normal"
                  lineHeight={"28px"}
                  letterSpacing={"-0.44px"}
                  fontWeight={500}
                >
                  Finding a buyer for your property or business is now easier
                  than ever with a focused, credible marketplace of qualified
                  investors and entrepreneuers.
                </Box>
              </PurposeContentContainer>
              <Box pos="relative">
                <Image
                  src="/images/about/right-blob.svg"
                  width={size.width >= 1050 ? "528px" : "370px"}
                  height={size.width >= 1050 ? "587px" : "410px"}
                  style={{
                    maxWidth: "100%",
                    height: "auto"
                  }} />
                <Box pos={"absolute"} top="105px" left="85px">
                  <Image
                    src="/images/about/property-and-business-owners.svg"
                    width={size.width >= 1050 ? "362px" : "245px"}
                    height={size.width >= 1050 ? "543px" : "325px"} />
                </Box>
              </Box>
            </Flex>
            <Flex justifyContent={"space-evenly"} height="770px" pb="130px">
              <Box pos="relative">
                <Image
                  src="/images/about/bottom-blob.svg"
                  width={size.width >= 1050 ? "552px" : "365px"}
                  height={size.width >= 1050 ? "514px" : "337px"}
                  style={{
                    marginTop: "35px",
                    maxWidth: "100%",
                    height: "auto"
                  }} />
                <Box pos={"absolute"} top="47px">
                  <Image
                    src="/images/about/industry-professionals.svg"
                    width={size.width >= 1050 ? "402px" : "245px"}
                    height={size.width >= 1050 ? "543px" : "325px"} />
                </Box>
              </Box>
              <PurposeContentContainer bottom>
                <Box
                  w={"561px"}
                  pt="16px"
                  color={"white"}
                  fontSize="44px"
                  lineHeight={"110%"}
                  letterSpacing={"-0.01em"}
                >
                  <Text>Industry professionals</Text>
                  <Text display={"block"} color="#c1bfbd">
                    By delivering high quality leads inside a refined toolkit
                  </Text>
                </Box>
                <Box
                  w="559px"
                  pt="17px"
                  color="#c1bfbd"
                  fontSize={"18px"}
                  fontStyle="normal"
                  lineHeight={"28px"}
                  letterSpacing={"-0.44px"}
                  fontWeight={500}
                >
                  Whether you’re a Realtor®, a Business Broker, an auctioneer,
                  a wholesaler, or a service provider, Zonado helps you take
                  your business to the next level. A toolkit of software
                  solutions unlike anything else in the industry and richer,
                  qualified leads help you close deals faster.
                </Box>
              </PurposeContentContainer>
            </Flex>
          </>
        ) : (
          <>
            <Flex flexDir={"column"} alignItems="center">
              <Image
                src="/images/about/investors-and-tenants.svg"
                width={"343px"}
                height={"440px"}
                style={{
                  borderRadius: "20px",
                  maxWidth: "100%",
                  height: "auto"
                }} />
              <PurposeContentContainerMobile>
                <Box>
                  <Text>Investors & Tenants</Text>
                  <Text color="#c1bfbd">
                    By removing the clutter from their search for a property{" "}
                  </Text>
                </Box>
                <Box
                  pt="16px"
                  pb="50px"
                  color="#c1bfbd"
                  fontSize={"18px"}
                  lineHeight={"26px"}
                >
                  From searching for an investment opportunity to finding a
                  space for a business to operate out of, the entire process
                  is becoming faster, easier, and more trustworthy on Zonado.
                </Box>
              </PurposeContentContainerMobile>
            </Flex>
            <Flex flexDir={"column"} alignItems="center">
              <Image
                src="/images/about/property-and-business-owners.svg"
                width={"343px"}
                height={"440px"}
                style={{
                  borderRadius: "20px",
                  maxWidth: "100%",
                  height: "auto"
                }} />
              <PurposeContentContainerMobile>
                <Box>
                  <Text>Property & business owners</Text>
                  <Text color="#c1bfbd">
                    By streamlining the search for a buyer
                  </Text>
                </Box>
                <Box
                  pt="16px"
                  pb="50px"
                  color="#c1bfbd"
                  fontSize={"18px"}
                  lineHeight={"26px"}
                >
                  Finding a buyer for your property or business is now easier
                  than ever with a focused, credible marketplace of qualified
                  investors and entrepreneuers.
                </Box>
              </PurposeContentContainerMobile>
            </Flex>
            <Flex flexDir={"column"} alignItems="center">
              <Image
                src="/images/about/industry-professionals.svg"
                width={"343px"}
                height={"440px"}
                style={{
                  borderRadius: "20px",
                  maxWidth: "100%",
                  height: "auto"
                }} />
              <PurposeContentContainerMobile>
                <Box>
                  <Text>Industry professionals</Text>
                  <Text color="#c1bfbd">
                    By delivering high quality leads inside a refined toolkit
                  </Text>
                </Box>
                <Box
                  pt="16px"
                  pb="50px"
                  color="#c1bfbd"
                  fontSize={"18px"}
                  lineHeight={"26px"}
                >
                  Whether you’re a Realtor®, a Business Broker, an auctioneer,
                  a wholesaler, or a service provider, Zonado helps you take
                  your business to the next level. A toolkit of software
                  solutions unlike anything else in the industry and richer,
                  qualified leads help you close deals faster.
                </Box>
              </PurposeContentContainerMobile>
            </Flex>
          </>
        )}
      </WrapperStyle>
    </Box>

    <WrapperStyle>
      <Flex
        m="99px 0 96px"
        w={"100%"}
        justifyContent="center"
        flexDir={"column"}
      >
        <ContactText>
          We are always eager to collaborate with others in our industry.{" "}
          <br /> <br /> Looking to partner? Let's chat!
        </ContactText>
        <Box m="0 auto">
          <Link href="/contact-us">

            <Button
              variant="outline"
              borderColor={"#223A5A"}
              color="#223A5A"
              fontWeight={500}
              w="129px"
              h="48px"
              mt="49px"
            >
              Contact us
            </Button>

          </Link>
        </Box>
      </Flex>
    </WrapperStyle>
  </>);
};

About_us.newLayout = true;

export default About_us;
